import { useAuth } from 'modules/auth/providers/AuthProvider';
import React from 'react';
import { ArrowDown, Logout, MenuIcon, PersonIcon } from 'ui/Icons';
import NavSideBar from 'ui/NavSideBar';
import investorsData from 'ui/theme/Header/data/investors.json';
import NavbarLinks from 'ui/theme/Header/NavbarLinks';
import RightItemSideNonLogg from 'ui/theme/Header/RightItemSideNonLogg';
import { LayoutInterface } from 'ui/uiTypes';

import {
  InvestorIcon,
  InvestorOption,
  MenuContent,
  MenuTitle,
  Option,
} from './style';

interface RightSideBarProps {
  isSecondary?: boolean;
  showLinks?: boolean;
  showSidebars?: boolean;
  isMobile?: boolean | 0 | undefined;
  loggedIn?: boolean;
  showRightSideBar: boolean;
  openRight: VoidFunction;
  closeRight: VoidFunction;
}

const RightSideBar = ({
  isSecondary,
  isSalesRep,
  showLinks,
  variant,
  showSidebars,
  isMobile,
  loggedIn,
  showRightSideBar,
  rightNonLoggMenu,
  openRight,
  closeRight,
}: RightSideBarProps & LayoutInterface) => {
  const { logout } = useAuth();
  const callLogout = () => {
    logout();
    closeRight();
  };

  if (isSalesRep) {
    return (
      <>
        <Option onClick={callLogout}>
          <Logout />
        </Option>
      </>
    );
  }
  return (
    <>
      {isSecondary ? (
        showLinks && <NavbarLinks variant={variant} desktop />
      ) : (
        <>
          {showSidebars && (
            <InvestorIcon data-testid="InvestorIcon" onClick={openRight}>
              {loggedIn ? (
                <>
                  <PersonIcon />
                  <ArrowDown />
                </>
              ) : isMobile ? (
                <MenuIcon color={'#000000'} height={30} width={30} />
              ) : (
                <RightItemSideNonLogg {...{ rightNonLoggMenu }} />
              )}
            </InvestorIcon>
          )}
          <NavSideBar
            data-testid="rightSideBar"
            active={showRightSideBar}
            side="right"
            onClickClose={closeRight}
          >
            {loggedIn && (
              <MenuTitle>
                <h2>Investors</h2>
                <InvestorIcon onClick={closeRight}>
                  <PersonIcon />
                  <ArrowDown rotate={'180'} />
                </InvestorIcon>
              </MenuTitle>
            )}
            <MenuContent>
              {loggedIn ? (
                <>
                  <InvestorOption bold>
                    <p>{'Investor, Joe (You)'}</p>
                  </InvestorOption>
                  {investorsData.investors.map((elem, index) => (
                    <InvestorOption key={index}>
                      <p>{`${elem.firstName}, ${elem.firstName}`}</p>
                    </InvestorOption>
                  ))}
                </>
              ) : (
                <RightItemSideNonLogg {...{ rightNonLoggMenu }} />
              )}
            </MenuContent>
          </NavSideBar>
        </>
      )}
    </>
  );
};
export default RightSideBar;
